import Swiper from "swiper/bundle";
window.Swiper = Swiper;
import 'swiper/css/bundle';
import 'jquery-nice-select';

/**
 * Load NPM libraries asynchronously to lower initial page load time.
 *
 * @returns {Promise<void>}
 */
async function loadPackages() {
    const { default: ComparisonSlider } = await import(/* webpackPrefetch: true */ "img-comparison-slider");
    const { default: Lottie } = await import(/* webpackPrefetch: true */ "@lottiefiles/lottie-player");
    const { default: Simplebar } = await import(/* webpackPrefetch: true */ "simplebar");
}

loadPackages();

import "./base/forms/select.js";
import "./base/functions/website-url.js";
import "./base/global/heading-parts.js";

import "./custom/components/add-to-cart-ajax";
import "./custom/components/blog.js";
import "./custom/components/case-study-results";
import "./custom/components/checkout-login-form-modal.js";
import "./custom/components/checkout-smart-coupons-component.js";
import "./custom/components/dermo-protocols-list.js";
import "./custom/components/home-hero-swiper.js";
import "./custom/components/hover-image";
import "./custom/components/how-we-create";
import "./custom/components/how-do-we-do-this-component.js";
import "./custom/components/ingredients-product-component.js";
import "./custom/components/ingredients-slider-block-component.js";
import "./custom/components/insta-carousel-component";
import "./custom/components/klarna-messaging.js";
import "./custom/components/landing-page.js";
import "./custom/components/nature-component";
import "./custom/components/order-details-modal";
import "./custom/components/our-essentials-component";
import "./custom/components/our-story-immunaturna";
import "./custom/components/our-story-from-our-founder";
import "./custom/components/products-search-component.js";
import "./custom/components/scientific-data";
import "./custom/components/shop-all-tutorial-tooltips.js";
import "./custom/components/single-product-accordion-component";
import "./custom/components/single-product-bottom-bar";
import "./custom/components/single-product-ingredients-modal";
import "./custom/components/single-product-items-order";
import "./custom/components/single-product-mobile-gallery";
import "./custom/components/three-items-image-component.js";
import "./custom/components/trial-url";
import "./custom/components/verdilab-clean-beauty";
import "./custom/components/verdilab-clean-beauty-swiper";
import "./custom/components/we-say-component";
import "./custom/components/what-is-immunaturna.js";
import "./custom/components/why-we-do-this-section";

import "./custom/custom";
import "./custom/header";
import "./custom/input-focus";
import "./custom/lazy-loading.js";
import "./custom/login-register-opener";
import "./custom/navigation"; //This cause annoying scroll top
import "./custom/wt-videos-autoplay-control";

import "./woocommerce/loop-slider.js";

